module.exports = __webpack_public_path__ + "static/media/lobby-fireplace.c63ea259.jpg";